import isStrictComparable from './_isStrictComparable.js';
import keys from './keys.js';

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

export default getMatchData;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_getMatchData.js
// module id = 1279
// module chunks = 0